

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface DischargeEntryParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface DischargeEntry {
    id?: any;
    regId:any;
    
    admissionId:any;
    CreatedById?:any;
   dischargeTypeId:any;
    dischargeActualDate:any;
    dischargeActualTime:any;
    dischargePlannedDate:any; 
    dischargePlannedTime:Date;
    dischargeAcceptance:string;	
    dischargeCancelFlag:string;	        
    dischargeCancelReason:string;	
    dischargeReferralHospital:string;	
    dischargeReferralNotes:string;	
    createdBy:string;	
    createdDate:any;
    cancelledDate:any;
   
   
    tenantId: any;
    branchId: any;
  
  parameters?: DischargeEntryParameter[];
  links?: any;
  visitId?:number;
  dischargeInstruction?:string;
} 

export abstract class DischargeEntryData {
  abstract getById(url: string): Observable<DischargeEntry>;
  abstract list(url: string): Observable<DischargeEntry[]>;
  abstract create(url: string, data: DischargeEntry): Observable<DischargeEntry[]>;
  abstract update(url: string, data: DischargeEntry): Observable<DischargeEntry>;
  abstract delete(url: string): Observable<any>;
 
}
